import { useEffect, useState, useMemo } from "react";
import styles from "./index.module.less";
import { useUser } from "@/utils/UserContext";
import { useNavigate } from "react-router-dom";
import playerImg from "@/assets/img/playerImg.png";
import { Iconsvg } from "@wk/components-react16";
import Icon from "@/components/Icon";
import { findValueByIdAndKey, isSubmissionClosed } from "@/utils";
import ModalConfirm from "./modal";

import {
  getKsDict,
  getDictIdByCode,
  getDictListById,
} from "@/services/history";

// 创建一个 BroadcastChannel 实例
const channel = new BroadcastChannel("move_to_section");

const Player = () => {
  const { user } = useUser();
  const [userInfo, setUserInfo] = useState();

  const [ksList, setKsList] = useState([]);
  const [zcList, setZcList] = useState([]);

  // 投稿截止提示弹窗
  const [isClosedOpen, setIsClosedOpen] = useState(false);

  // 投稿是否已截止（截止后禁用提交案例入口）
  const submissionClosed = isSubmissionClosed();

  const getCaseTypeDict = async (code) => {
    try {
      const resList = await getDictIdByCode({ code });
      const id = resList?.result?.records[0]?.id || "";
      const itemList = await getDictListById({ dictId: id, pageSize: -1 });
      return itemList?.result?.records || [];
    } catch (error) {
      return [];
    }
  };

  const getZcList = async () => {
    const zcList = await getCaseTypeDict("zc");
    setZcList(zcList);
  };

  const zcText = useMemo(() => {
    return findValueByIdAndKey(zcList, userInfo?.zhicheng, "itemText") || "--";
  }, [zcList, userInfo]);

  const ksText = useMemo(() => {
    const value = userInfo?.keshi;
    if (!value) return "--";

    return value
      .split(",")
      .map((item) => findValueByIdAndKey(ksList, item, "title", "key"))
      .join("、");

    // return findValueByIdAndKey(ksList, userInfo?.keshi, "title", "key") || "--";
  }, [ksList, userInfo]);

  useEffect(() => {
    setUserInfo(user || {});
  }, [user]);

  useEffect(() => {
    getKsDict().then((res) => {
      setKsList(res.result || []);
    });
    getZcList();
  }, []);

  const navigate = useNavigate();
  return (
    <div className={styles["player-box"]}>
      {/* <img src={banner1} alt="" className="img-fluid" /> */}

      <div className="player-banner">
        <div className="name">{userInfo?.userName}</div>
        <div className="ks">{ksText}</div>
        <div className="zc">{zcText}</div>
      </div>

      <div className="player-content">
        <div className="left-box">
          <img src={playerImg} alt="" className="img-fluid" />
          <div className="info">
            <div>
              <div className="content">
                <div className="title">4月27日</div>
                <div className="desc">赛事启动</div>
              </div>
              <div className="line">
                <div></div>
              </div>
            </div>

            <div>
              <div className="content">
                <div className="title">6月1日-10月11日</div>
                <div className="desc">全国投稿</div>
              </div>
              <div className="line">
                <div></div>
              </div>
            </div>

            <div>
              <div className="content">
                <div className="title">11月17日</div>
                <div className="desc">公布决赛名单</div>
              </div>

              <div className="line">
                <div></div>
              </div>
            </div>

            <div>
              <div className="content">
                <div className="title">11月下旬</div>
                <div className="desc">决赛赛前训练营</div>
              </div>

              <div className="line">
                <div></div>
              </div>
            </div>

            <div>
              <div className="content">
                <div className="title">12月21日</div>
                <div className="desc">决赛评审启动</div>
              </div>

              <div className="line">
                <div></div>
              </div>
            </div>

            <div>
              <div className="content">
                <div className="title">2027年2月4日</div>
                <div className="desc">稿件返修</div>
              </div>
               <div className="line">
                <div></div>
              </div>
            </div>

            <div>
              <div className="content">
                <div className="title">2027年3月下旬</div>
                <div className="desc">公布决赛结果</div>
              </div>
            </div>

          </div>
        </div>
        <div className="right-box">
          <div
            className={submissionClosed ? "first-box disabled" : "first-box"}
            onClick={() => {
              // 投稿截止后不允许再提交案例
              if (submissionClosed) {
                setIsClosedOpen(true);
                return;
              }
              if (userInfo && userInfo?.status === "1") {
                navigate("/player/personalCases/add");
              } else {
                navigate("/login");
              }
            }}
          >
            <Icon icon={"shijiaoanli"} style={{ fontSize: "100px" }} />

            <div className="btn-box">
              <div>提交案例</div>
              <Iconsvg name="arrow-right" size={16} color="#FFFFFF"></Iconsvg>
            </div>
          </div>
          <div className="second-box">
            <div onClick={() => navigate("/player/detail")}>
              <Iconsvg name="user" size={32} color="#474747"></Iconsvg>
              <div className="text">个人信息</div>
            </div>

            <div onClick={() => navigate("/player/personalCases")}>
              <Iconsvg name="mail-address" size={32} color="#474747"></Iconsvg>
              <div className="text">查看个人案例</div>
            </div>

            <div onClick={() => navigate("/privacyPolicy")}>
              <Iconsvg name="shield" size={32} color="#474747"></Iconsvg>
              <div className="text">隐私条款</div>
            </div>

            <div
              onClick={() => {
                // 跳转到首页
                // navigate("/");
                // setTimeout(() => {
                //   // 发送消息
                //   channel.postMessage("faq");
                //   channel.close();
                // }, 1000);

                // 跳转到常见问题页面;
                navigate("/question");
              }}
            >
              <Iconsvg name="question" size={32}></Iconsvg>
              <div className="text">常见问题</div>
            </div>
          </div>
        </div>
      </div>

      <ModalConfirm
        isOpen={isClosedOpen}
        onClose={() => {
          setIsClosedOpen(false);
        }}
        children={
          <div className="modal-body-text">投稿已截止，无法提交案例</div>
        }
        title={"操作确认"}
        onConfirm={() => {
          setIsClosedOpen(false);
        }}
        okText="确认"
      />
    </div>
  );
};
export default Player;
